<template>
    <b-container fluid class="p-0 activity-container" v-if="show">
        <b-row no-gutters>
            <b-col class="ml-3" cols="12">
                <b-button class="activity-button" variant="info" @click="close"> &#60; Close Activity</b-button>
            </b-col>
            <b-col cols="12">
                <iframe :src="url" frameborder="0" class="iframe">
                </iframe>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {EventBus, Activity} from '../Utils'

    export default {
        name: "ActivityContainer",
        data() {
            return {
                show: false,
                url: ''
            }
        },
        methods: {
            close() {
                this.url = ''
                this.show = false
            },
        },
        created() {
            EventBus.$on(Activity.ACTIVITY_OPEN, (url) => {
                this.url = url
                this.show = true
            })
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"

    .activity-container
        position fixed
        height 100%
        width 100%
        background-color white
        z-index 9999999999

    .activity-button
        color color-green-light
        &:not(:disabled):not(.disabled).active, &:not(:disabled):not(.disabled):active,
        &:hover
            color color-green-dark

    .iframe
        height calc(100vh - 30px)
        width 100%
</style>
